import { css } from "@emotion/react";

export const resetButton = css`
    appearance: none;
    background-color: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: block;
    font-family: inherit;
    outline: none;
    padding: 0;
`;

export const resetH = css`
    font-family: "Lexend Deca", sans-serif;
    text-transform: none;
`;

export const visuallyHidden = css`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    trpr__padding: 0;
    position: absolute;
    width: 1px;
`;

export const wrapperCSS = css`
    --gap-wrapper: 24px;

    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;
    width: calc(100% - var(--gap-wrapper) * 2);

    @media (min-width: 597px) {
        --gap-wrapper: 48px;
    }

    @media (min-width: 1141px) {
        --gap-wrapper: 120px;
    }
`;

export const hideImgAlt = css`
    overflow: hidden;
    text-indent: 100%;
    text-indent: 200%; /* HACK: hide text on iOS */
    white-space: nowrap;
`;
